export default "__VITE_ASSET__gZCZ3xz9__"